import type { Result } from "../shared/result";

type GetRestrictedStreamingKeysForVideoGroupSetRequest = {
  eventId: string;
  videoGroupSetId: string;
  code: string;
};

export type GetRestrictedStreamingKeysForVideoGroupSetResponse = Result<
  {
    streamingStatus: "beforeLive" | "live" | "beforeVOD" | "vod" | "ended";
    // videoId -> 署名付き Cookie 入りの streamingSource
    streamingSources: {
      [videoId: string]: {
        default: StreamingCookie;
      };
    };
  },
  {
    status: "notfound" | "unavailable";
  }
>;

export type GetRestrictedStreamingKeysForVideoGroupSet = {
  path: (typeof getRestrictedStreamingKeysForVideoGroupSet)["path"];
  request: GetRestrictedStreamingKeysForVideoGroupSetRequest;
  response: GetRestrictedStreamingKeysForVideoGroupSetResponse;
};

export const getRestrictedStreamingKeysForVideoGroupSet = {
  path: "getRestrictedStreamingKeysForVideoGroupSet",
} as const;

/**
 * 配信 Cookie
 */
type StreamingCookie = {
  cookie: {
    "CloudFront-Key-Pair-Id": string;
    "CloudFront-Policy": string;
    "CloudFront-Signature": string;
  };
  cors: boolean;
  url: string;
  liveOffset?: number;
};
